var React = require('react');

function Trash (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m9.827 6.158-.231 6m-3.192 0-.23-6m6.645-2.14c.228.034.454.071.681.11m-.681-.11-.712 9.255a1.5 1.5 0 0 1-1.496 1.385H5.389a1.5 1.5 0 0 1-1.496-1.385l-.712-9.255m9.638 0a32.085 32.085 0 0 0-2.319-.265m-7.319.265c-.228.034-.454.07-.681.11m.681-.11c.77-.116 1.543-.205 2.319-.265m5 0v-.61c0-.787-.607-1.443-1.393-1.468a34.65 34.65 0 0 0-2.214 0C6.107 1.7 5.5 2.356 5.5 3.142v.611m5 0a32.446 32.446 0 0 0-5 0","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Trash.defaultProps = {"viewBox":"0 0 16 16","fill":"none"};

module.exports = Trash;

Trash.default = Trash;
